import { PlayerColor } from '@colonist/game-states';
import { CardDataController } from '@colonist/game-card-types';
export const STARTING_SETTLEMENT_AMOUNT = 5;
export function getInitialPlayerState(playerColor, isConnected, cardDiscardLimit, activeResourceCardTypes) {
    return {
        color: playerColor,
        victoryPointsState: {},
        bankTradeRatiosState: getDefaultBankTradeRatiosState(activeResourceCardTypes),
        resourceCards: {
            cards: []
        },
        cardDiscardLimit: cardDiscardLimit,
        isConnected: isConnected,
        isTakingAction: false
    };
}
function getDefaultBankTradeRatiosState(activeResourceCardTypes) {
    if (activeResourceCardTypes == undefined) return {};
    const defaultTradeRatio = 4;
    const activeResourceCards = CardDataController.getCardEnumsOfTypes(activeResourceCardTypes);
    const bankTradeRatiosState = {};
    activeResourceCards.forEach((cardEnum)=>bankTradeRatiosState[cardEnum] = defaultTradeRatio);
    return bankTradeRatiosState;
}
export function getEmptyPlayerState() {
    return getInitialPlayerState(PlayerColor.None, true, 7, []) // TODO: Check if setting DeviceType to web causes bugs
    ;
}
